export const POST_ON_CALL_POLICY = "POST_ON_CALL_POLICY";
export const POST_ON_CALL_POLICY_FAIL = "POST_ON_CALL_POLICY_FAIL";
export const POST_ON_CALL_POLICY_SUCCESS = "POST_ON_CALL_POLICY_SUCCESS";
export const EDIT_ON_CALL_POLICY = "EDIT_ON_CALL_POLICY";
export const EDIT_ON_CALL_POLICY_FAIL = "EDIT_ON_CALL_POLICY_FAIL";
export const EDIT_ON_CALL_POLICY_SUCCESS = "EDIT_ON_CALL_POLICY_SUCCESS";
export const GET_ON_CALL_POLICY = "GET_ON_CALL_POLICY";
export const GET_ON_CALL_POLICY_FAIL = "GET_ON_CALL_POLICY_FAIL";
export const GET_ON_CALL_POLICY_SUCCESS = "GET_ON_CALL_POLICY_SUCCESS";
export const GET_SPECIFIC_ON_CALL_POLICY = "GET_SPECIFIC_ON_CALL_POLICY";
export const GET_SPECIFIC_ON_CALL_POLICY_FAIL = "GET_SPECIFIC_ON_CALL_POLICY_FAIL";
export const GET_SPECIFIC_ON_CALL_POLICY_SUCCESS = "GET_SPECIFIC_ON_CALL_POLICY_SUCCESS";
export const DELETE_SPECIFIC_ON_CALL_POLICY = "DELETE_SPECIFIC_ON_CALL_POLICY";
export const DELETE_SPECIFIC_ON_CALL_POLICY_FAIL = "DELETE_SPECIFIC_ON_CALL_POLICY_FAIL";
export const DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS = "DELETE_SPECIFIC_ON_CALL_POLICY_SUCCESS";
export const GET_ONCALL_ELIGIBLE_USERS = "GET_ONCALL_ELIGIBLE_USERS";
export const GET_ONCALL_ELIGIBLE_USERS_SUCCESS = "GET_ONCALL_ELIGIBLE_USERS_SUCCESS";
export const GET_ONCALL_ELIGIBLE_USERS_FAIL = "GET_ONCALL_ELIGIBLE_USERS_FAIL";